export default __webpack_public_path__ + "static/media/microwave.f78cb488.svg";